// Apps Routes
import accountAdmin from './account.admin';
import announceAdmin from './announce.admin';
import codeAdmin from './code.admin';
import companyAdmin from './company.admin';
import keepitalAdmin from './keepital.admin';
import minisitesAdmin from './minisites.admin';
import plansAdmin from './plans.admin';
import procurementAdmin from './procurement.admin';
import showcaseAdmin from './showcase.admin';
// Public Routes
import accountPublic from './account.public';
import announcePublic from './announce.public';
import commercePublic from './commerce.public';
import companyPublic from './company.public';
import keepitalPublic from './keepital.public';
import messengerPublic from './messenger.public';
import plansPublic from './plans.public';
import userPublic from './user.public';

export default [
  // Admin
  ...accountAdmin,
  ...announceAdmin,
  ...codeAdmin,
  ...companyAdmin,
  ...keepitalAdmin,
  ...minisitesAdmin,
  ...plansAdmin,
  ...procurementAdmin,
  ...showcaseAdmin,
  // Public
  ...accountPublic,
  ...keepitalPublic,
  ...announcePublic,
  ...commercePublic,
  ...companyPublic,
  ...messengerPublic,
  ...plansPublic,
  ...userPublic,
];
